import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import Paper from '@mui/material/Paper';
import { availableOffersTitles } from '../../../../constants/factoring/summary-titles';
import { ONBOARDING_PAPER_CLASS_NAME } from '../../../../theme/constants/paper';
import DocumentSummary from '../../../../components/summaries/DocumentSummary';

const AvailableOffersCessionStep = ({
  setShowCessionStep,
  countryConfig,
  getShoppingCartProps,
  showGoBackButton,
}) => {
  const handleCloseCessionStep = useCallback(() => {
    setShowCessionStep(false);
  }, [setShowCessionStep]);

  return (
    <DocumentSummary
      summaryTitle={availableOffersTitles.cessionSummaryTitle}
      summaryDescription={availableOffersTitles.cessionSummaryDescription}
      documentTypeId="offers-cession"
      SummaryTable={(
        <Paper className={ONBOARDING_PAPER_CLASS_NAME} sx={{ maxWidth: 768, minHeight: 250, mx: 'auto' }}>
          <countryConfig.ShoppingCartComponent
            {...getShoppingCartProps(handleCloseCessionStep)}
          />
        </Paper>
      )}
      showGoBackButton={showGoBackButton}
      showTableInMobile
      onGoBackClick={handleCloseCessionStep}
    />
  );
};

AvailableOffersCessionStep.propTypes = {
  setShowCessionStep: PropTypes.func.isRequired,
  countryConfig: PropTypes.shape({
    ShoppingCartComponent: PropTypes.elementType.isRequired,
  }).isRequired,
  getShoppingCartProps: PropTypes.func.isRequired,
  showGoBackButton: PropTypes.bool,
};

AvailableOffersCessionStep.defaultProps = {
  showGoBackButton: false,
};

export default AvailableOffersCessionStep;
